
import Main from "../Main.vue";

export default {
  components: {
    Main,
  },
};
